export const hosts = {
  //LUZ
  API_BASE: 'https://ms.luzca.com',
  //Merkafur
  //API_BASE: 'https://ms.merkafur.com',
  //roselab
  //API_BASE: 'https://ms.roselab.com',


  PORT_SEC: '24025',
  PORT_MRP: '24035',
  PORT_SRM: '24045',
  PORT_MPC: '24055',
  PORT_TMS: '24065',
  PORT_IMS: '24075',
  PORT_HCM: '24085',
  PORT_POS: '24095',
  PORT_FMS: '24105',
  PORT_CONF: '24115',
  PORT_TASKS: '24125',
  PORT_BI: '24135',
  PORT_CRM: '24155',
};

export const environment = {
  appVersion: require('../../package.json').version,
  production: true,

  //key Merkafur
  FLEX_MONSTER_KEY : 'Z707-XDBE09-0P2E33-145M0A-242D4W-08301K-2G0H3D-542K4M-2I2064-4E',

  //Security
  API_BASE_URL_AUTHENTICATION: `${hosts.API_BASE}:${hosts.PORT_SEC}/sec-authe`,
  API_BASE_URL_AUTHORIZATION: `${hosts.API_BASE}:${hosts.PORT_SEC}/sec-autho`,

  //MRP
  API_BASE_URL_ROOM_MANAGER: `${hosts.API_BASE}:${hosts.PORT_MRP}/room-manager`,
  API_BASE_URL_PRODUCTION_ORDER: `${hosts.API_BASE}:${hosts.PORT_MRP}/prod-orders`,
  API_BASE_URL_MRP_ANALYTICS: `${hosts.API_BASE}:${hosts.PORT_MRP}/analytics`,

  //SRM
  API_BASE_URL_SRM_MASTERS: `${hosts.API_BASE}:${hosts.PORT_SRM}/srm-masters`,
  API_BASE_URL_SRM_SUPPLIER: `${hosts.API_BASE}:${hosts.PORT_SRM}/suppliers`,
  API_BASE_URL_PURSCHASE_ORDER: `${hosts.API_BASE}:${hosts.PORT_SRM}/purchase-orders`,
  API_BASE_URL_SRM_MERCHANDISE_RECEPTION: `${hosts.API_BASE}:${hosts.PORT_SRM}/merchandise-reception`,
  API_BASE_URL_SRM_PURCHASE_RETURN: `${hosts.API_BASE}:${hosts.PORT_SRM}/purchase-return`,
  API_BASE_URL_SRM_ANALYTICS: `${hosts.API_BASE}:${hosts.PORT_SRM}/analytics`,

  //MPC
  API_BASE_URL_PRODUCT_MANAGEMENT: `${hosts.API_BASE}:${hosts.PORT_MPC}/product-manager`,
  API_BASE_URL_BRANCH_OFFICE_PRODUCT: `${hosts.API_BASE}:${hosts.PORT_MPC}/branch-office-prod`,
  API_BASE_URL_OSM_MASTERS: `${hosts.API_BASE}:${hosts.PORT_MPC}/osm-master`,
  API_BASE_URL_OSM_MULTIMEDIA: `${hosts.API_BASE}:${hosts.PORT_MPC}/mpc-media`,
  API_BASE_URL_OSM_MPC_ANALYTICS: `${hosts.API_BASE}:${hosts.PORT_MPC}/analytics`,
  API_BASE_URL_ECOMMERCE_IMAGE_INTEGRATION: `${hosts.API_BASE}:${hosts.PORT_MPC}/ecomm-image-integration`,

  //TMS
  API_BASE_URL_OSM_TMSMasters: `${hosts.API_BASE}:${hosts.PORT_TMS}/tms-masters`,
  API_BASE_URL_OSM_MERCHANDISE_REQUEST: `${hosts.API_BASE}:${hosts.PORT_TMS}/merchan-request`,
  API_BASE_URL_OSM_MERCHANDISE_TRANSFERS: `${hosts.API_BASE}:${hosts.PORT_TMS}/merchan-transfer`,
  API_BASE_URL_OSM_TMS_ANALYTICS: `${hosts.API_BASE}:${hosts.PORT_TMS}/analytics`,

  //HCM
  API_BASE_URL_HCM_MASTERS: `${hosts.API_BASE}:${hosts.PORT_HCM}/hcm-masters`,
  API_BASE_URL_HCM_HR: `${hosts.API_BASE}:${hosts.PORT_HCM}/hr`,
  API_BASE_URL_HCM_PAYROLL: `${hosts.API_BASE}:${hosts.PORT_HCM}/payroll`,
  API_BASE_URL_HCM_PAYROLL_ENGINE: `${hosts.API_BASE}:${hosts.PORT_HCM}/payroll-engine`,
  API_BASE_URL_HCM_ANALYTICS: `${hosts.API_BASE}:${hosts.PORT_HCM}/analytics`,

  //FMS
  API_BASE_URL_FINANCIAL_MASTER: `${hosts.API_BASE}:${hosts.PORT_FMS}/fms-masters`,
  API_BASE_URL_FINANCIAL: `${hosts.API_BASE}:${hosts.PORT_FMS}/financial`,
  API_BASE_URL_BANK_TRANSACTIONS: `${hosts.API_BASE}:${hosts.PORT_FMS}/banks-transactions`,
  API_BASE_URL_RECEIVABLE_ACCOUNTS: `${hosts.API_BASE}:${hosts.PORT_FMS}/receivable-accounts`,
  API_BASE_URL_FINANCIAL_ANALYTICS: `${hosts.API_BASE}:${hosts.PORT_FMS}/analytics`,
  API_BASE_URL_PAYMENT_ACCOUNTS: `${hosts.API_BASE}:${hosts.PORT_FMS}/payment-accounts`,

  //CONF
  API_BASE_URL_GENERAL_MASTERS: `${hosts.API_BASE}:${hosts.PORT_CONF}/masters`,
  API_BASE_URL_TELERIK_REPORT: `${hosts.API_BASE}:${hosts.PORT_CONF}/telerik-report`,
  API_BASE_URL_REPORTS: `${hosts.API_BASE}:${hosts.PORT_CONF}/reports`,

  // BI
  API_BASE_URL_BI: `${hosts.API_BASE}:${hosts.PORT_BI}/bi`,

  //TASKS
  API_BASE_URL_TASKS: `${hosts.API_BASE}:${hosts.PORT_TASKS}/tasks`,

  //IMS
  API_BASE_URL_OSM_IMS_ANALYTICS: `${hosts.API_BASE}:${hosts.PORT_IMS}/analytics`,
  API_BASE_URL_OSM_IMS: `${hosts.API_BASE}:${hosts.PORT_IMS}/ims`,

  //POS
  API_BASE_URL_SOM_ANALYTICS: `${hosts.API_BASE}:${hosts.PORT_POS}/analytics`,
  API_BASE_URL_STORE_MANAGER: `${hosts.API_BASE}:${hosts.PORT_POS}/store-manager`,

  // Mobile
  API_BASE_URL_MOBILE: `${hosts.API_BASE}:${hosts.PORT_POS}/mobile`
};
